import {configureStore} from "@reduxjs/toolkit";
import userReducer from "./usersSlice";

export const store = configureStore({
  reducer: userReducer,
  devTools: true
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch